import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIncidentType } from "../../redux/actionCreator";
import {
  details_validated,
  incident_type_details,
  updateRedux,
} from "../../redux/commonReducer";
import { onNextButtonValidation, sizeCalculation } from "../../utils/validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

export default function Page3({
  setStage,
  setInputs,
  inputs,
  setInputErrors,
  inputErrors,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = localStorage.getItem('lang')
  const navigate = useNavigate()

  const incident_type_list = useSelector(incident_type_details);
  const detailValidated = useSelector(details_validated);

  const [modalshow, setModalShow] = useState(false);
  const [fileView, setFileView] = useState(null);

  useEffect(() => {
    dispatch(getIncidentType());
    setInputErrors({})
  }, []);

  const handleClose = () => {
    setModalShow(false);
    setFileView(null);
  };

  async function onNextButtonHandle() {
    const isValidated = await onNextButtonValidation(
      {
        incident_type: inputs.incident_type._id,
        entity: inputs.entity,
        // date: inputs.date,
        reported_elsewhere: inputs.reported_elsewhere,
        description: inputs.description,
        files: inputs.files
      },
      setInputErrors
    );
    dispatch(updateRedux({ key: "details_validated", value: isValidated }));
    // console.log(inputErrors)
    if (isValidated === true) {
      setInputErrors({});
      if (inputs?.files?.length != 0) {
        let temp = [];
        let size = null;
        inputs?.files?.forEach((ele) => {
          const file = ele;
          const fileType = file.name
            .substr(file.name.lastIndexOf(".") + 1)
            .toLowerCase();
          // console.log(fileType);
          size = size + ele.size;
          if (["jpg", "jpeg", "png", "pdf", "PDF", "mp4", "mov"].includes(fileType)) {
            setInputErrors({ ...inputErrors, files: "" });
            // setStage(4);
          } else {
            temp.push(ele);
            setInputErrors({
              ...inputErrors,
              files:
                t('please_upload_files_with_jpeg_jpg_png_pdf_mp4_formats'),
            });
          }
        });
        // console.log(size);
        const fileSize = Math.round(size / 1024);
        // console.log(fileSize);
        if (fileSize > 100 * 1024) {
          setInputErrors({
            ...inputErrors,
            files: t("file_too_big_please_select_files_less_than_50mb"),
          });
        }
        if (fileSize <= 100 * 1024 && temp?.length == 0) {
          // setStage(4);
          navigate(`/${lang}/report_incident/review_submit`)
        }
      } else {
        // setStage(4);
        navigate(`/${lang}/report_incident/review_submit`)
      }
    }
  }

  const fileViewHandler = (file) => {
    setFileView(file);
    setModalShow(true);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props.label}
    </Tooltip>
  );

  return (
    // console.log(inputs?.files),
    <div className="Page3 container">
      <Modal
        show={modalshow}
        centered
        onHide={handleClose}
        className="removeModfal preview-modal"
      >
        <Modal.Body>
          {fileView != null ? (
            <div>
              {fileView?.type === "image/jpeg" ||
                fileView?.type === "image/jpg" ||
                fileView?.type === "image/webp" ||
                fileView?.type === "image/png" ? (
                <img
                  className="file"
                  src={URL.createObjectURL(fileView)}
                  alt=""
                />
              ) : fileView.type === "video/mp4" || fileView.type === "video/mov" || fileView.type === "video/quicktime" ? (
                <video
                  src={URL.createObjectURL(fileView)}
                  width="320"
                  height="240"
                  controls
                ></video>
              ) : null}
            </div>
          ) : null}
          <p className="file-name">{fileView?.name}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={handleClose}>
            {t('close')}
          </button>
        </Modal.Footer>
      </Modal>
      <h2>{t("Please_fill_in_the_details_of_the_incident")}</h2>
      <div className="inputs">
        <div className="input-group">
          {/* <select
              type="text"
              placeholder={t("incident_type") + "*"}
              className={inputErrors.incident_type ? "error" : ""}
              value={inputs.incident_type}
              onChange={(e) => (
                setInputs((s) => ({ ...s, incident_type: e.target.value })),
                setInputErrors({})
              )}
            >
              <option value="" selected hidden disabled>
                {t('incident_type')}*
              </option>
              {incident_type_list?.map((ele, i) => {
                return <option value={ele._id}>{ele.incident_type}</option>;
              })}
            </select> */}
          <Select
            name="incident"
            options={incident_type_list}
            hideSelectedOptions={false}
            value={inputs.incident_type}
            getOptionLabel={(option) => {
              if (lang === "en") {
                return option?.incident_type
              } else {
                return option?.incident_type_ar
              }
            }}
            getOptionValue={(option) => option._id}
            className={"basic-multi-select" + (inputErrors.incident_type ? " error" : "")}
            classNamePrefix="select"
            placeholder={`${t("incident_type")}*`}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#e0e0e0",
                primary: "#e0e0e0",
              },
            })}
            onChange={(e) => {
              setInputs((s) => ({ ...s, incident_type: e }));
              setInputErrors({ ...inputErrors, incident_type: "" });
            }}
          />
          <div className="text-danger">
            <small>{t(inputErrors.incident_type)}</small>
          </div>
        </div>
        <div className="input-group">
          <input
            type="text"
            placeholder={t("name_of_entity") + "*"}
            className={inputErrors.entity ? "error" : ""}
            value={inputs.entity}
            maxLength={150}
            onChange={(e) => (
              setInputs((s) => ({ ...s, entity: e.target.value })),
              setInputErrors({ ...inputErrors, entity: "" })
            )}
          />
          <div className="text-danger">
            <small>{t(inputErrors.entity)}</small>
          </div>
        </div>
        <div className="input-group">
          <img src="/assets/img/icons/calendar.svg" className="calendar" alt="" />
          <DatePicker
            selected={inputs.date}
            onChange={(date) => {
              setInputs((s) => ({ ...s, date: date }));
              setInputErrors({ ...inputErrors, date: "" });
            }}
            maxDate={new Date()}
            dateFormat="yyyy-MM-dd"
            className={inputErrors.date ? "error" : ""}
            placeholderText={`${t("date_of_incident")}`}
          />
          <div className="text-danger">
            <small>{t(inputErrors.date)}</small>
          </div>
        </div>
        <div className="input-group">
          <div className="radio-question">
            {t("is_this_incident_reported_elsewhere?")}*
            <div className="labels">
              <label htmlFor="">
                {t("yes")}
                <input
                  type="radio"
                  name="incident-prev-status"
                  id=""
                  value="Yes"
                  checked={inputs.reported_elsewhere == "Yes"}
                  onChange={(e) => (
                    setInputs((s) => ({
                      ...s,
                      reported_elsewhere: e.target.value,
                    })),
                    setInputErrors({ ...inputErrors, reported_elsewhere: "" })
                  )}
                />
              </label>
              <label htmlFor="">
                {t("no")}
                <input
                  type="radio"
                  name="incident-prev-status"
                  id=""
                  value="No"
                  checked={inputs.reported_elsewhere == "No"}
                  onChange={(e) => (
                    setInputs((s) => ({
                      ...s,
                      reported_elsewhere: e.target.value,
                    })),
                    setInputErrors({ ...inputErrors, reported_elsewhere: "" })
                  )}
                />
              </label>
            </div>
          </div>
          <div className="text-danger">
            <small>{t(inputErrors.reported_elsewhere)}</small>
          </div>
        </div>
        <div className="input-group textarea">
          <textarea
            type="text"
            placeholder={t("description") + "*"}
            maxLength={2000}
            minLength={8}
            rows="5"
            value={inputs.description}
            className={inputErrors.description ? "error" : ""}
            onChange={(e) => (
              setInputs((s) => ({ ...s, description: e.target.value })),
              setInputErrors({ ...inputErrors, description: "" })
            )}
          />
          <div className="text-danger">
            <small>{t(inputErrors.description)}</small>
          </div>
        </div>
        <p className="max-info">
          <img src="./assets/img/icons/security-dark.svg" alt="" />
          {t("maximum_2000_characters_allowed")}
        </p>
      </div>
      <div className="attachment-files">
        {inputs.files &&
          inputs.files.map((file, i) => {
            return (
              <>
                {
                  file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/webp" ||
                    file.type === "image/png" ? (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip({
                        label: file.name,
                      })}
                    >
                      <span className="file-container">
                        <img
                          className="file"
                          src={URL.createObjectURL(file)}
                          alt=""
                          onClick={() => fileViewHandler(file)}
                        />
                        <img
                          className="file-close"
                          src="./assets/img/icons/Group 11563.svg"
                          alt=""
                          onClick={() => {
                            setInputs((s) => ({
                              ...s,
                              files: s.files.filter((item) => file != item),
                            }));
                            setInputErrors({
                              ...inputErrors,
                              files: "",
                            });
                          }}
                        />
                      </span>
                    </OverlayTrigger>
                  ) : file.type === "application/pdf" ? (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip({
                        label: file.name,
                      })}
                    >
                      <span className="file-container">
                        <a href={`${URL.createObjectURL(file)}`} target="_blank" rel="noreferrer">
                          <img
                            className="file"
                            src="./assets/img/icons/Group 11807.png"
                            alt=""
                          />
                        </a>
                        <img
                          className="file-close"
                          src="./assets/img/icons/Group 11563.svg"
                          alt=""
                          onClick={() => {
                            setInputs((s) => ({
                              ...s,
                              files: s.files.filter((item) => file != item),
                            }));
                            setInputErrors({
                              ...inputErrors,
                              files: "",
                            });
                          }}
                        />
                      </span>
                    </OverlayTrigger>
                  ) : file.type === "video/mp4" || file.type === "video/mov" || file.type === "video/quicktime" ? (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip({
                        label: file.name,
                      })}
                    >
                      <span className="file-container">
                        <img
                          className="file"
                          src="./assets/img/icons/v1.png"
                          alt=""
                          onClick={() => fileViewHandler(file)}
                        />
                        <img
                          className="file-close"
                          src="./assets/img/icons/Group 11563.svg"
                          alt=""
                          onClick={() => {
                            setInputs((s) => ({
                              ...s,
                              files: s.files.filter((item) => file != item),
                            }));
                            setInputErrors({
                              ...inputErrors,
                              files: "",
                            });
                          }}
                        />
                      </span>
                    </OverlayTrigger>
                  ) :
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip({
                        label: file.name,
                      })}
                    >
                      <span className="file-container error-file">
                        <img
                          className="file"
                          src="./assets/img/icons/error file.svg"
                          alt=""
                          onClick={() => fileViewHandler(file)}
                        />
                        <img
                          className="file-close"
                          src="./assets/img/icons/Group 11563.svg"
                          alt=""
                          onClick={() => {
                            setInputs((s) => ({
                              ...s,
                              files: s.files.filter((item) => file != item),
                            }));
                            setInputErrors({
                              ...inputErrors,
                              files: "",
                            });
                          }}
                        />
                      </span>
                    </OverlayTrigger>
                }
              </>
            );
          })}
      </div>
      <div className="buttons">
        <div className="buttons attachmentBtn">
          <div className="row1">
            <label className="attachment" htmlFor="upload-attachment">
              <img src="./assets/img/icons/Icon awesome-upload.svg" alt="" />
              <input
                type="file"
                name=""
                id="upload-attachment"
                accept=".jpg, .png, .pdf, .jpeg, .PDF, .mp4 , .mov"
                multiple
                hidden
                onClick={(e) => e.target.value = null}
                onChange={(e) =>
                  setInputs((s) => ({
                    ...s,
                    files: [...s.files, ...Array.from(e.target.files)],
                  }))
                }
              />
              {t("add_attachments")}
            </label>
            {/* <span className="supported__formats">
              <p>{t('attachment_file_types')} </p>
              <p> {t('attachment_file_size')} </p>
            </span> */}
          </div>
          <div className="text-danger">
            <small>{t(inputErrors.files)}</small>
          </div>
        </div>
      </div>
      <div className="navigation-buttons">
        <button className="next-button" onClick={() => {
          // setStage(2)
          navigate(`/${lang}/report_incident/personal_information`)
        }}>
          <img className="left arrow" src="./assets/img/icons/Icon awesome-arrow-right.svg" alt="" />
          {t('back')}
        </button>
        <button
          onClick={onNextButtonHandle}
          className={`next-button ${inputs.incident_type == "" ||
            inputs.entity?.trim() == "" ||
            inputs.reported_elsewhere == "" ||
            inputs.description?.trim() == ""
            ? `disabled`
            : ""
            }`}
          disabled={
            inputs.incident_type == "" ||
            inputs.entity?.trim() == "" ||
            inputs.reported_elsewhere == "" ||
            inputs.description?.trim() == ""
          }
        >
          {t("next")}
          <img className="right" src="./assets/img/icons/Icon awesome-arrow-right.svg" alt="" />
        </button>
      </div>
    </div>
  );
}
